import {BehaviorSubject} from "rxjs"
import axios from "axios"
import {authenticate_uri, current_user_uri} from "./uri"
import {errorService} from "./handle-error"
import {jwtHeader} from "./jwt-header"

const currentUserLocalPath = "currentUser"
const currentUserSubject = new BehaviorSubject(getWithExpiry(currentUserLocalPath))

const login = (username, password) => {
	return axios.post(authenticate_uri, {}, {
		auth: {
			username: username,
			password: password
		}
	})
	.then((jwtResponse) => {
		const jwtToken = jwtResponse.data
		return axios.get(current_user_uri, jwtHeader(jwtToken))
		.then(userResponse => {
			const user = userResponse.data
			user.jwtToken = jwtToken
			setWithExpiry(currentUserLocalPath, user, 1000 * 60 * 60)
			currentUserSubject.next(user)
			return user
		})
		.catch(errorService.handleError)
	})
	.catch(errorService.handleLoginError)
}

function setWithExpiry(key, value, ttl) {
	const now = new Date()
	const item = {
		value: value,
		expiry: now.getTime() + ttl
	}
	localStorage.setItem(key, JSON.stringify(item))
}

function getWithExpiry(key) {
	const itemStr = localStorage.getItem(key)
	if (!itemStr) {
		return null
	}
	const item = JSON.parse(itemStr)
	const now = new Date()
	if (now.getTime() > item.expiry) {
		localStorage.removeItem(key)
		return null
	}
	return item.value
}

const logout = () => {
	localStorage.removeItem(currentUserLocalPath)
	currentUserSubject.next(null)
}

export const authenticationService = {
	login,
	logout,
	currentUser: currentUserSubject.asObservable(),
	get currentUserValue() {
		return currentUserSubject.value
	}
}